import { render } from "./Search4Channel.vue?vue&type=template&id=54e07698&scoped=true"
import script from "./Search4Channel.vue?vue&type=script&lang=js"
export * from "./Search4Channel.vue?vue&type=script&lang=js"

import "./Search4Channel.vue?vue&type=style&index=0&id=54e07698&lang=sass&scoped=true"
import "./Search4Channel.vue?vue&type=style&index=1&id=54e07698&lang=sass"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e07698"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QBtn,QField});
